import React, { Component } from 'react';
import ActionBar from '@mui/icons-material/LocalBar';
import config from "../config";
import { Link, withRouter } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { getRight, getToken } from '../services/storage';

const baseItemStyle = {
    marginLeft: '8px',
    marginRight: '8px',
    width: 'calc(100% - 16px)',
    borderRadius: '6px',
    paddingLeft: '8px',
    paddingTop: '6px',
    paddingBottom: '6px',
    minHeight: 'auto',
    transition: 'all 0.2s ease',
};

const activeItemStyle = {
    ...baseItemStyle,
    backgroundColor: '#08607e',
    color: '#ffffff',
};

class BarListSidebarView extends Component {
    constructor() {
        super();
        this.state = {
            token: getToken(),
            right: getRight()
        };
    }

    render() {
        let items = [];
        if (this.state.token && (this.state.right >= config.permissions.ADMIN.value))
            items = this.props.items ? this.props.items : [];

        const currentPath = this.props.location ? this.props.location.pathname : window.location.pathname;
        const pname = currentPath ? currentPath.split("/") : null;

        let dateBegin = null;
        let dateEnd = null;

        if (pname && pname.length === 4) {
            dateBegin = pname[2];
            dateEnd = pname[3];
        } else if (pname && pname.length === 5) {
            dateBegin = pname[3];
            dateEnd = pname[4];
        }

        let itemsView = items.map((item) => {
            if (!item) return null;

            const targetLink = (dateBegin && dateEnd) ? (item.link + '/' + dateBegin + '/' + dateEnd) : item.link;
            const isActive = currentPath === targetLink || (item.link && currentPath.startsWith(item.link));

            return (
                <ListItem
                    button
                    component={Link}
                    key={item.name}
                    to={targetLink}
                    style={isActive ? activeItemStyle : baseItemStyle}
                >
                    <ListItemIcon style={{ minWidth: '40px', color: isActive ? '#ffffff' : '#495057' }}>
                        <ActionBar />
                    </ListItemIcon>
                    <ListItemText 
                        primary={item.name} 
                        primaryTypographyProps={{ 
                            style: { 
                                color: isActive ? '#ffffff' : '#000000', 
                            } 
                        }}
                    />
                </ListItem>
            );
        });

        return (
            <>
                {itemsView}
            </>
        );
    }
}

export default withRouter(BarListSidebarView);